import React, { useState } from "react";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import { Modal } from "reactstrap";
import Homecontact from "./Homecontact";

function BuyLicense() {
      const [modal, setModal] = useState<boolean>(false);
      const toggle = () => setModal(!modal);
      const [selectedPurpose, setSelectedPurpose] = useState("");
    const [modalTitle, setModalTitle] = useState("");
    
    
    const openModal = (type: string) => {
      setSelectedPurpose(type);
      setModalTitle(type);
      setModal(true);
    };
  return (

    
    
    
    <div
  style={{
    background: "linear-gradient(135deg,#020617,#0f172a,#111827)",
    color: "#fff",
    borderRadius: "20px",
    padding: "60px 40px",
    marginBottom: "40px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)"
  }}
>

     <header className="hero-section">
          <img
            src="/Img/Creologo-New.webp"
            alt="Catiaa CAA Logo"
            className="hero-image"
          />
          <h1 className="hero-title">
           Buy Creo Toolkit Development License
          </h1>

      

          <h5
            style={{
              color: "#a6aaac",
              lineHeight: "1.8",
              fontSize: "18px",
              maxWidth: "900px",
              margin: "0 auto",
              textAlign: "center",
              fontWeight: 400,
            }}
          >
          Develop powerful Creo Parametric applications using the official
    Creo Toolkit SDK. Get licensing guidance, pricing information,
    and expert consultation for your automation and customization projects.
          </h5>
        </header>

  <div className="row g-4 mb-5">

<div className="col-md-4">

<div
style={{
background:"#1e293b",
borderRadius:20,
padding:30,
boxShadow:"0 5px 18px rgba(0,0,0,.08)",
height:"100%"
}}
>

<h3  className="d-flex">
 <span>🏗</span>  <span style={{ fontWeight: "bold", fontSize:"35px",color: "#38bdf8" , marginLeft:"10px"}}>Creo Parametric</span>
</h3>
<p>
Industry-leading 3D CAD software used for product design,
mechanical engineering, manufacturing, simulation,
and digital product development.
</p>

</div>

</div>

<div className="col-md-4">

<div
style={{
background:"#1e293b",
borderRadius:20,
padding:30,
boxShadow:"0 5px 18px rgba(0,0,0,.08)",
height:"100%"
}}
>
<h3  className="d-flex">
 <span>⚙</span>  <span style={{ fontWeight: "bold", fontSize:"35px",color: "#38bdf8" , marginLeft:"10px"}}>Creo Toolkit</span>
</h3>

<p>
Official C++ SDK for developing custom commands,
plug-ins, automation tools, UI extensions,
and engineering applications for Creo.
</p>

</div>

</div>

<div className="col-md-4 ">

<div
style={{
background:"#1e293b",
borderRadius:20,
padding:30,
boxShadow:"0 5px 18px rgba(0,0,0,.08)",
height:"100%"
}}
>
<h3  className="d-flex">
 <span>💻</span>  <span style={{ fontWeight: "bold", fontSize:"35px",color: "#38bdf8" , marginLeft:"10px"}}>Developers</span>
</h3>
<h3> </h3>

<p>
Essential for software companies and engineering teams
building commercial Creo automation,
customization, and enterprise integration solutions.
</p>

</div>

</div>

</div>
<div 
style={{
 background: "linear-gradient(135deg,#020617,#0f172a,#111827)",
color:"#fff",
padding:"50px",
borderRadius:20,
textAlign:"center",
marginTop:50,
marginBottom:"100px"
}}
>

<h2>Need a Creo Toolkit License?</h2>

<p
style={{
fontSize:18,
marginTop:15
}}
>
Our licensing specialists will help you choose the right
Creo Toolkit development license based on your project
requirements and provide a customized quotation.
</p>

<button
  onClick={(e) => {
                 e.stopPropagation();
                openModal("Creo Get Instant Quote");
               }}
className="btn btn-primary btn-lg mt-3"
style={{
borderRadius:40,
padding:"12px 40px",
fontWeight:600
}}
>
Request Instant Quote
</button>

</div>

<div className="row g-4 mb-5">

{[
"Custom Commands",
"Ribbon & Menu Customization",
"Creo Plug-ins",
"CAD Automation",
"Drawing Automation",
"BOM Automation",
"Windchill Integration",
"Engineering Applications"
].map(item=>(
<div className="col-md-3">

<div
style={{
background:"#1e293b",
border:"1px solid #000000",
borderRadius:15,
padding:25,
textAlign:"center",
height:"100%",
transition:".3s"
}}
>



<h5>{item}</h5>

</div>

</div>
))}

</div>


<div
style={{
borderRadius:20,
overflow:"hidden",
boxShadow:"0 8px 20px rgba(0,0,0,.08)"
}}
>

<div
  className="table-responsive"
  style={{
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
    background: "#fff",
    alignItems:"center"
  }}
>
  <table className="table mb-0 align-middle">
    <thead
      style={{
        background: "linear-gradient(90deg, #004aad, #0d6efd)",
        color: "#fff",
      }}
    >
      <tr>
        <th className="py-3 px-4 text-center" >
          🏗 Standard Creo License
        </th>
        <th className="py-3 px-4 text-center">
          ⚙️ Creo Toolkit License
        </th>
      </tr>
    </thead>

    <tbody className="text-center">
      <tr>
    <td>✅ Use Creo Parametric</td>

<td>💻 Develop Creo Applications</td>

</tr>

<tr>

<td>📦 Create CAD Models</td>

<td>🧩 Build Plug-ins</td>

</tr>

<tr>

<td>📐 Generate Drawings</td>

<td>🛠 Create Custom Commands</td>
</tr>

<tr>

<td>⚙ Standard CAD Features</td>

<td>🔗 Access Creo Toolkit APIs</td>

</tr>

<tr>

<td>📝 Manual Design Tasks</td>

<td>🤖 Automate Engineering Workflows</td>
      </tr>
    </tbody>
  </table>
</div>

</div>


<div className="row text-center my-5">

{[
["1000+","Engineering Companies"],
["500+","Automation Solutions"],
["30+","Industries Served"],
["24/7","Technical Support"]
].map(([number,title])=>(

<div className="col-md-3">

<div
style={{
background:"#1e293b",
padding:30,
borderRadius:20,
boxShadow:"0 5px 18px rgba(0,0,0,.08)"
}}
>

<h1
style={{
color:"#0da5fd",
fontWeight:"700"
}}
>
{number}
</h1>

<h5>{title}</h5>

</div>

</div>

))}

</div>



{/* DEMO VIDEO */}
        <div className="cta-section"

        >

          <h1
            className="section-title"
          >
            Demo Videos
          </h1>

          <p
            style={{
              textAlign: "center",
              maxWidth: "1200px",
              margin: "0 auto ",
              color: "#cbd5e1",
              lineHeight: "1.8",
              fontSize: "18px",
            }}
          >
            Before seeking more information on CREO automation and customization,
            watch introductory videos to understand the basics and assess your interest.
          </p>

          <div className="video-grid"

          >
            {/* Video 1 */}
            <div className="video-card" >
              <h3 className="video-title">
                CAD Customization & Automation
              </h3>
<LiteYouTubeEmbed
  id="VpcpMwvQJy4"
  title="Creo Toolkit Demo"
  noCookie={true}
  poster="maxresdefault"
/>
            </div>

            {/* Video 2 */}
            <div className="video-card" >
              <h3 className="video-title">
                Sample Creo Toolkit Customization
              </h3>

                            <LiteYouTubeEmbed
  id="poccCwHW7ok"
  title="Creo Toolkit Demo"
  noCookie={true}
  poster="maxresdefault"
/>
            </div>

            {/* Video 3 */}
            <div className="video-card" >
              <h3 className="video-title">
                SOLIDWORKS API Sample Project
              </h3>

              <LiteYouTubeEmbed
  id="XXTr_xjRZto"
  title="Creo Toolkit Demo"
  noCookie={true}
  poster="maxresdefault"
/>
            </div>

            {/* Video 4 */}
            <div className="video-card" >
              <h3 className="video-title">
                NX Open API Programming
              </h3>

<LiteYouTubeEmbed
  id="URpFRWwxFD0"
  title="Creo Toolkit Demo"
  noCookie={true}
  poster="maxresdefault"
/>

            </div>
          </div>
        </div>

         <Modal style={{maxWidth:"900px"}}
  isOpen={modal}
  toggle={toggle}
  size="lg"
  centered
  backdrop={false}
>
  <Homecontact purpose={selectedPurpose} closeModal={toggle} />
</Modal>



</div>

  );
}

export default BuyLicense;